import { Container } from '@mantine/core';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { DetailsLayout } from '@apple/ui/layouts/DetailsLayout';
import { LoadingOverlay } from '@apple/ui/loading-overlay';
import { NotFoundPage } from '@apple/ui/shell/pages/NotFoundPage';
import { NotAuthorizedError } from '@apple/utils/api/errors';

import { requireAuth } from '@apple/features/auth/utils/require-auth';
import { StoreBudgetReport } from '@apple/features/store/components/StoreBudgetReport';
import { useRetailStore } from '@apple/features/store/hooks/useRetailStore';

export const Route = createFileRoute('/_authed/stores_/$storeCode/budget')({
	errorComponent: ({ error }) => {
		if (error instanceof NotAuthorizedError) {
			return <NotFoundPage />;
		} else {
			throw error;
		}
	},
	parseParams: ({ storeCode }) => ({
		storeCode: z.string().parse(storeCode),
	}),
	validateSearch: z.object({
		fiscalYear: z.number().optional(),
		fiscalPeriod: z.number().optional(),
	}),
	beforeLoad: args => {
		requireAuth(args);
	},
	component: BudgetReportRoute,
});

export function BudgetReportRoute() {
	const { storeCode } = Route.useParams();
	const { fiscalYear, fiscalPeriod } = Route.useSearch();

	const { auth } = Route.useRouteContext();

	const store = useRetailStore(storeCode ?? auth.profile?.singleStoreCustomerCode);

	if (store.storeQuery.isLoading || !store.storeQuery.data) {
		return <LoadingOverlay visible />;
	}

	return (
		<DetailsLayout title='Store Budget'>
			<Container fluid mt='md'>
				<StoreBudgetReport
					fiscalYear={fiscalYear}
					periodNumber={fiscalPeriod}
					storeCode={store.storeQuery.data.arvatoCustomerCode}
					storeName={store.storeQuery.data.storeName}
				/>
			</Container>
		</DetailsLayout>
	);
}
